import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { MLayoutService } from './layout.service';

@Component({
  selector: 'm-layout',
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'mLayout',
  host: {
    class: 'm-layout'
  }
})
export class MLayoutComponent implements OnDestroy {
  subscription = new Subscription();
  showHeader = true;
  sideMenuVisible = true;
  menuVisible = true;

  constructor(private cdr: ChangeDetectorRef, private layoutService: MLayoutService) {
    this.subscription.add(
      this.layoutService.headerVisible$.subscribe((open: boolean) => {
        this.showHeader = open;
        this.cdr.markForCheck();
      })
    );
    this.subscription.add(
      this.layoutService.sideMenuVisible$.subscribe(value => {
        this.sideMenuVisible = value;
        this.cdr.markForCheck();
      })
    );

    this.subscription.add(
      this.layoutService.menuVisible$.subscribe(value => {
        this.menuVisible = value;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
